import "./assets/base.css";

import { createApp } from "vue";
import App from "./App.vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faPlay,
  faPause,
  faVolumeHigh,
  faVolumeMute,
  faCircleNotch,
} from "@fortawesome/free-solid-svg-icons";

import PrimeVue from "primevue/config";
import Aura from '@primeuix/themes/aura';
import Select from "primevue/select";
import Calendar from "primevue/calendar";
import Card from "primevue/card";
import DatePicker from "primevue/datepicker";

import { vueKeycloak } from "@josempgon/vue-keycloak";

import { api_config, SKIP_AUTH } from "./env";
import { initAnalytics } from "./analytics";

library.add(faPlay, faPause, faVolumeHigh, faVolumeMute, faCircleNotch);

const app = createApp(App);

app.component("font-awesome-icon", FontAwesomeIcon);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    semantic: {
      primary: {
        50: '{green.50}',
        100: '{green.100}',
        200: '{green.200}',
        300: '{green.300}',
        400: '{green.400}',
        500: '{green.500}',
        600: '{green.600}',
        700: '{green.700}',
        800: '{green.800}',
        900: '{green.900}',
        950: '{green.950}'
      }
    },
    options: {
      prefix: 'p',
      darkModeSelector: 'light-mode',
      cssLayer: false
    }
  }
});
app.component("DropDown", Select);
app.component("PrimeCalendar", Calendar);
app.component("PrimeCard", Card);
app.component("DatePicker", DatePicker);

async function initAppWithKeycloak() {
  await new Promise<void>((resolve, reject) => {
    app.use(vueKeycloak, {
      config: {
        url: api_config.keycloak_url,
        realm: api_config.keycloak_realm,
        clientId: api_config.keycloak_client_id,
      },
      initOptions: {
        onLoad: "login-required",
        enableLogging: true,
      },
    });
    resolve();
  });

  app.mount("#app");
}

// If skipping, attach a dummy keycloak instance.
async function initApp(SKIP_AUTH: boolean) {
  if (SKIP_AUTH) {
    console.log("skipping authentication");
    app.mount("#app");
  } else {
    // Otherwise, use the vueKeycloak plugin.
    initAppWithKeycloak().catch((error) => {
      console.error("Keycloak initialization error:", error);
    });
  }
}

initAnalytics();
initApp(SKIP_AUTH);
